import React, { Component } from 'react';
import './AddItem.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faStickyNote } from '@fortawesome/free-regular-svg-icons';
import { faPlus } from '@fortawesome/free-solid-svg-icons';

export default class AddItem extends Component {
  constructor(props) {
    super(props);

    this.imgURL = 'black';

    this.widget = window.cloudinary.createUploadWidget(
      {
        cloudName: 'dtp68ybqr',
        uploadPreset: 'zxloubyq'
      },
      (error, result) => {
        this.checkUpdateResult(result);
      }
    );

    this.state = {
      fields: [
        {
          id: 'name',
          value: ''
        },
        {
          id: 'category',
          value: ''
        },
        {
          id: 'src',
          value: ''
        },
        {
          id: 'rating',
          value: ''
        },
        {
          id: 'time',
          value: ''
        }
      ],
      active: false
    };
    this.onChange = this.onChange.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.display = this.display.bind(this);
    this.checkUpdateResult = this.checkUpdateResult.bind(this);
  }

  onSubmit(e) {
    e.preventDefault();
    const item = {};
    this.state.fields.forEach(field => (item[field.id] = field.value));
    console.log(item);
    this.props.onClick(item);
    document.getElementsByName('addItemForm')[0].reset();
  }

  onChange(e) {
    const id = e.target.name;
    const val = e.target.value;
    this.setState({
      fields: this.state.fields.map(field => {
        let value = field.id === id ? val : field.value;
        return { id: field.id, value, name: field.name, key: field.key };
      })
    });
  }

  hideStyle = () => {
    return {
      display: this.state.active === true ? 'flex' : 'none'
    };
  };

  display() {
    let active = !this.state.active;
    this.setState({ active: active });
  }

  showWidget(widget) {
    widget.open();
  }

  checkUpdateResult = resultEvent => {
    if (resultEvent.event === 'success') {
      this.setState({
        fields: this.state.fields.map(field => {
          let value =
            field.id === 'src' ? resultEvent.info.secure_url : field.value;
          return { id: field.id, value, name: field.name, key: field.key };
        })
      });
    }
  };

  imageBoxStyle = () => {
    let url = '';
    this.state.fields.forEach(
      field => (url = field.id === 'src' ? field.value : url)
    );
    url = url !== '' ? 'url(' + url + ')' : 'white'; //1b4e5a17
    return { background: url };
  };

  render() {
    return (
      <div
        style={{
          display: 'flex',
          justifyContent: 'flex-end'
        }}
      >
        <div
          style={{
            marginRight: '1em',
            fontSize: '1.1em',
            display: 'flex',
            alignItems: 'center'
          }}
          className="btn"
          onClick={this.display}
        >
          <FontAwesomeIcon
            icon={faPlus}
            size="sm"
            style={{ marginRight: '.5em' }}
          />{' '}
          Neu
        </div>
        <div className="add-item-page" style={this.hideStyle()}>
          <form action="" onSubmit={this.onSubmit} name="addItemForm">
            <div className="title">
              <h2>
                <FontAwesomeIcon icon={faStickyNote} />
                Neues Rezept
              </h2>
            </div>
            <div className="form-rows">
              <div className="form-row">
                <div
                  style={this.imageBoxStyle()}
                  className="upload-img"
                  onClick={this.showWidget.bind(this, this.widget)}
                ></div>
              </div>
              <div className="form-row">
                <div className="form-text">Rezeptname</div>
                <input type="text" name="name" onChange={this.onChange} />
              </div>
              <div className="form-row">
                <div className="form-text">Kategorie</div>
                <select name="category" onChange={this.onChange}>
                  <option value="">Wählen</option>
                  <option value="Vorspeise">Vorspeise</option>
                  <option value="Hauptspeise">Hauptspeise</option>
                  <option value="Nachspeise">Nachspeise</option>
                  <option value="Sonstiges">Sonstiges</option>
                </select>
              </div>
            </div>
            <div className="form-row">
              <input type="submit" className="btn" value="Hinzufügen" />
              <input
                type="button"
                className="btn btn-gray"
                value="Abbrechen"
                onClick={this.display}
              />
            </div>
          </form>
        </div>
      </div>
    );
  }
}
